<template>
  <div class="countdown panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
